import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const DeleteStdLoans = () => {
    const [StdLoan, setStdLoan] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchDeletedStdLoan();
    }, []);

    const fetchDeletedStdLoan = async () => {
        try {
            console.log('Fetching deleted student loans...');
            const response = await fetch('https://api.myskills.lk/stdLoans/deleted');
            console.log('Response status:', response.status);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log('Fetched data:', data);
            setStdLoan(data);
        } catch (error) {
            console.error('Error fetching deleted Student Loans:', error);
        }
    };

    const handleRestore = async (StdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to restore this student loan?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, restore it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/stdLoans/restore/${StdLoanId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        // Update local state after successful restoration
                        const updatedStdLoans = StdLoan.filter(StdLoan => StdLoan.id !== StdLoanId);
                        setStdLoan(updatedStdLoans);
                        
                        // Show success message
                        Swal.fire({
                            title: "Restored!",
                            text: "The student loan has been restored.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to restore student loan');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to restore the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error restoring student loan:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to restore the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    const handlePermanentDelete = async (StdLoanId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the student loan. This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete permanently!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/stdLoans/delete/permanent/${StdLoanId}`, {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        // Update local state after successful deletion
                        const updatedStdLoans = StdLoan.filter(StdLoan => StdLoan.id !== StdLoanId);
                        setStdLoan(updatedStdLoans);
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The student loan has been permanently deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete student loan permanently');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to permanently delete the student loan.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting student loan permanently:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to permanently delete the student loan.",
                        icon: "error"
                    });
                }
            }
        });
    };

    // Filter student loans based on search term
    const filteredStdLoans = StdLoan.filter(loan => 
        (loan.degreeName && loan.degreeName.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.university && loan.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.institutePhone && loan.institutePhone.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.instituteEmail && loan.instituteEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (loan.instituteLocation && loan.instituteLocation.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearchSubmit = (e) => {
        e.preventDefault(); // Prevent form submission
    };

    return (

        <div>

            <AdminDashboard />

            <div className='AllViews-admin-course'>                <div className="search-icon-admin admin-course-search">
                    <h1>DELETE STUDENT LOANS</h1>
                    <form onSubmit={handleSearchSubmit}>
                        <input 
                            type="text" 
                            placeholder='Search Item' 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                                <tr>
                                   <th>Degree Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>Contact No.</th>
                                    <th>Email</th>
                                    <th>Location</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {filteredStdLoans.map((StdLoan) => (
                                    <tr key={StdLoan.id}>
                                        <td>{StdLoan.degreeName}</td>
                                        <td>{StdLoan.university}</td>
                                        <td>{new Date(StdLoan.startDate).toLocaleDateString('en-CA')}</td>
                                        <td>{StdLoan.duration}</td>
                                        <td>{StdLoan.institutePhone}</td>
                                        <td>{StdLoan.instituteEmail}</td>
                                        <td>{StdLoan.instituteLocation}</td>
                                        <td>
                                            <a href="#!" id='view-website'>WEBSITE</a>
                                        </td>
                                        <td id='action-buttons'>
                                            <a href="#!" id='restore-details' onClick={() => handleRestore(StdLoan.id)}>RESTORE</a>
                                            <a href="#!" id='del-details' onClick={() => handlePermanentDelete(StdLoan.id)}>DELETE</a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )

}

export default DeleteStdLoans